import ExpandMore from "@mui/icons-material/ExpandMore"
import { MenuItem, TextField } from "@mui/material"
import {
  ChangeEvent,
  CSSProperties,
  Dispatch,
  SetStateAction,
  useState,
} from "react"

import { getColorVariables } from "src/components/layouts/basic/BasicLayout.variables"
import { create } from "src/helpers/bem"
import { defaultIncident } from "src/helpers/defaultIncident"
import { TranslationMessages } from "src/translations"
import { xRMApiIncidentType } from "src/types/xRM"

import { ModifiedIncident } from "."
import styles from "./IncidentTypeSelect.module.scss"

const bem = create(styles, "IncidentTypeSelect")
const style = { ...getColorVariables(undefined) }

type IncidentTypeSelectProps = {
  incident: ModifiedIncident
  messages: TranslationMessages
  setIncident: Dispatch<SetStateAction<ModifiedIncident>>
}

export const IncidentTypeSelect = ({
  messages,
  incident,
  setIncident,
}: IncidentTypeSelectProps) => {
  const [expanded, setExpanded] = useState<boolean>(false)

  const items = [
    "Claim",
    "Cancellation",
    "AuthorizationRequest",
  ] as xRMApiIncidentType[]
  const { incidentType } = incident
  const incidentMessages = messages.pages.account.overview.profile.incidents

  const handleChangeIncidentType = (event: ChangeEvent<HTMLInputElement>) => {
    const newIncidentType = event.target.value as xRMApiIncidentType
    setIncident({ ...defaultIncident, incidentType: newIncidentType })
  }

  return (
    <TextField
      select
      className={bem(undefined, "medium")}
      disabled={true}
      id="incident-type-selection"
      sx={{ color: styles.color }}
      value={incidentType}
      variant="standard"
      InputProps={{
        inputProps: { className: bem("input") },
        disableUnderline: true,
      }}
      SelectProps={{
        renderValue: () =>
          incidentType && `${incidentMessages.table.type.items[incidentType]}`,
        onOpen: () => {
          setExpanded(true)
        },
        onClose: () => setExpanded(false),
        IconComponent: ExpandMore,
        MenuProps: {
          slotProps: { paper: { className: bem("wrapper", "medium") } },
          MenuListProps: {
            className: bem("menu"),
            style: style as CSSProperties,
          },
        },
        className: bem("select", expanded ? "expanded" : ""),
      }}
      onChange={handleChangeIncidentType}
    >
      {items
        .filter((item) => item !== incidentType)
        .map((item) => (
          <MenuItem key={item} className={bem("menuitem")} value={item}>
            {`${incidentMessages.table.type.items[item]}`}
          </MenuItem>
        ))}
    </TextField>
  )
}

export default IncidentTypeSelect
